export const languages = [
    {
        code: 'en',
        localeName: 'English',
    },
    {
        code: 'fr',
        localeName: 'Français',
    },
    {
        code: 'it',
        localeName: 'Italiano',
    },
    {
        code: 'de',
        localeName: 'Deutsch',
    },
    {
        code: 'es',
        localeName: 'Espanol',
    },
    {
        code: 'fi',
        localeName: 'Finnish',
    },
    {
        code: 'sv',
        localeName: 'Swedish',
    },
    {
        code: 'nl',
        localeName: 'Dutch',
    },
]
